import { useState, useEffect } from "react";
import { GigyaGroupModels } from "../types/gigya.schema";

export const useCreateInvitation = () => {
  const [loadingInvitationLink, setLoadingInvitationLink] = useState(true);
  const [invitationLinkError, setInvitationLinkError] = useState(false);
  const [invitationLink, setInvitationLink] = useState("");
  const [groupId, setGroupId] = useState("");

  useEffect(() => {
    if (groupId) {
      window.gigya.accounts.groups.createInvitation({
        model: GigyaGroupModels.ClinicModel,
        groupId,
        callback: (resp) => {
          if (resp.errorCode) {
            console.log("Error Details: ", resp.errorDetails);
            setLoadingInvitationLink(true);
            setInvitationLinkError(true);
          } else {
            setInvitationLink(
              `${resp.invitationLink}&clinic=${groupId.toString()}`,
            );
            setLoadingInvitationLink(false);
            setInvitationLinkError(false);
          }
        },
      });
    }

    return () => {
      setInvitationLink("");
    };
  }, [groupId]);

  return {
    invitationLink,
    loadingInvitationLink,
    invitationLinkError,
    setGroupId,
  };
};
